import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { P } from 'xpi-black-ui/Base/Typography';
import Operations from 'components/Feature/Operations';

import { LoadOperations } from 'redux-flow/actions/operations';

import Tag from './styles';

export default function OtherOperations() {
  const dispatch = useDispatch();
  const { operations } = useSelector(({ Operation }) => Operation);

  useEffect(() => {
    if (operations.length === 0) {
      dispatch(LoadOperations());
    }
  }, []);


  let otherOperations = operations.filter(operationPage => operationPage.selected)[0] || [];

  if (otherOperations?.length === 0) {
    otherOperations = operations[0]
  }

  return (
    <>
      {operations.length > 0 && (
        <Tag>
          <P bigger bold style={{ marginBottom: '16px' }}>Outras operações disponíveis</P>
          <Operations operations={otherOperations.operations.slice(0, 4)} />
        </Tag>
      )}
    </>
  );
}
